export default "__VITE_ASSET__2465155e__"